module.exports = [{"name":"HERO","layout":"CONTENT_LEFT","hasCTA":true,"class":"half-bottom","assetName":"bravenet_sslcertificates_secure_lock_icon"},{"name":"ENCRYPT_TRUST_RELIABILITY","embed":{"component":"card-container","props":{"boxes":["ENCRYPT","TRUST","RELIABILITY"]}},"bare":true},{"name":"SEO","layout":"CONTENT_RIGHT","hasCTA":true,"class":"flush-bottom accent","assetName":"bravenet_sslcertificates_seo_boost"},{"name":"ECOMMERCE","layout":"CONTENT_LEFT","assetName":"bravenet_sslcertificates_ecommerce_support"}]


//////////////////
// WEBPACK FOOTER
// ./apps/www.bravenet.com/src/assets/data/sslcertificates/panels.json
// module id = 3p/D
// module chunks = 0